module.exports = __webpack_public_path__ + "static/media/reply.f5a4e8ad.svg";